import { render, staticRenderFns } from "./DealItemOptions.vue?vue&type=template&id=6828bb44&scoped=true&"
import script from "./DealItemOptions.vue?vue&type=script&lang=js&"
export * from "./DealItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./DealItemOptions.vue?vue&type=style&index=0&id=6828bb44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828bb44",
  null
  
)

export default component.exports